/**
 * axios的封装
 */
// 引入axios
import axios from 'axios';
// 引入qs 
import qs from 'qs';

import local from './local'
// import { Message } from 'element-ui';
import router from '../router';

// 设置请求的服务器根目录
axios.defaults.baseURL = 'http://youbesunstore.youbesun.com'
// axios请求拦截器
// axios.interceptors.request.use(config => {
//     // 获取token
//     const session = local.get('b_e_s_i_n');
//     config.headers.authorization = `Bearer ${session}` 
//     return config;
// })
// 响应拦截器
// axios.interceptors.response.use(response => {
//     if(response.data.code === 1012){
//         Message.error({message: "登录信息已经过期，请重新登录"})
//         router.push('/')
//     }else{
//         return response
//     }
// })

export default {
    // get方式
    get (url, params={}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {params})
            .then(response => {
                resolve(response.data) // 成功的数据
            })
            .catch(err => {
                reject(err) // 失败的数据
            })
        })
    },
    // post方式
    post (url, params={}) {
        return new Promise((resolve, reject) => {
            axios.post(url, qs.stringify(params))
            .then(response => {
                resolve(response.data) // 成功的数据
            })
            .catch(err => {
                reject(err) // 失败的数据
            })
        })
    },
    //delete方式
    delete (url, params={}) {
        return new Promise((resolve, reject) => {
            axios.delete(url, {params})
            .then(response => {
                resolve(response.data) // 成功的数据
            })
            .catch(err => {
                reject(err) // 失败的数据
            })
        })
    },
}

